// @flow
import {applyMiddleware, compose, createStore} from 'redux';

type StoreArgs = {
    debug: boolean,
    initialState?: Object,
    middlewares: Array<Function>,
    reducer: [Function],
};

function makeStore({debug, initialState, middlewares, reducer}: StoreArgs) {
    const composeEnhancers = debug && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            trace: true,
        }) :
        compose;
    return createStore(
        reducer,
        initialState,
        composeEnhancers(
            applyMiddleware(...middlewares),
        )
    );
}

export {makeStore};
